<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="visible"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="toCancel"
      no="1"
    >
      <!--      <div>-->
      <!--        <iframe src="https://vgm.hgj.com/service-area?from=woxing&head=hide" width="100%" height="400px" scrolling="auto" />-->
      <!--      </div>-->
      <div no="2" class="text1">{{ $t('SeaExport.ScopeServices') }}</div>
      <div no="3" class="h-px" />
      <div no="4" class="title">{{ $t('OperationGuide.Title1') + vgmCarriers.length + $t('OperationGuide.Title2') }}</div>
      <div no="5" class="service-scope">
        <div no="6" class="el-tabs__nav">
          <div
            v-for="port in ports"
            :key="port.name"
            :class="['el-tabs__item', { active: activeTab === port.name }]"
            no="7"
            @click="onClickTab(port.name)"
          >
            {{ port.name }}
          </div>
        </div>
        <div>
          <button
            v-for="company in showVgmCarriers"
            :key="company.name"
            class="button"
            no="8"
          >
            {{ company.name }}
          </button>
        </div>
      </div>
      <span slot="footer" style="padding:10px">
        <el-button no="toCancel" @click="toCancel">{{ $t('SeaExport.Close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'VgmServiceGuide',
  props: {
    visible: { type: Boolean, required: true },
    ports: { type: Array, required: true, default: () => [] },
    vgmCarriers: { type: Array, required: true, default: () => [] }
  },
  data() {
    return {
      activeTab: this.ports.length > 0 ? this.ports[0].name : ''
    }
  },
  computed: {
    showVgmCarriers() {
      if (!this.activeTab) {
        return []
      }
      return this.vgmCarriers.filter(item => item.filterValue.indexOf(this.activeTab) > -1)
    }
  },
  watch: {
    ports: {
      handler(newPorts) {
        // 当 ports 变化时，更新 activeTab
        if (newPorts.length > 0) {
          this.activeTab = newPorts[0].name
        } else {
          this.activeTab = ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toCancel() {
      this.$emit('close')
    },
    onClickTab(name) {
      this.activeTab = name
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-inner ::v-deep .el-dialog__body {
  padding: 10px;
}
/deep/ .el-dialog__header {
  border-bottom: 0px;
}
.text1 {
  height: 30px !important;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: .5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: rgb(40, 40, 40);
}

.h-px {
  height: 1px !important;
  background-color: rgb(229, 229, 229);
}

.title {
  padding: 20px 20px 0;
  font-size: 14px;
  line-height: 30px;
  font-weight: 700;
  color: rgb(40, 40, 40);
}
.el-tabs__nav {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 10px;
}
.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #7a8699;
  cursor: pointer;
}
.el-tabs__item.active {
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}
.service-scope {
  display: flex;
  flex-direction: column;
}
.button {
  margin: 5px;
  padding: 10px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #333;
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
}
</style>
